import React from "react";
import { Image, View, FlatList, TouchableOpacity, Dimensions, Pressable } from "react-native";
import { useTheme } from "@emotion/react";
import { ODSText } from "../../../openbrix-design-system/ui/atoms/ODSText";
import getScreenType from "../../../openbrix-design-system/utils/getScreenType";
import Wrapper from "./Wrapper";
import YoutubePlayer from '../../commonComponents/youtubePlayer/youtubePlayer';
const HeaderWeb = require('../../../openbrix-design-system/images/tlyfe-pages/home-web.png');
const HeaderTab = require('../../../openbrix-design-system/images/tlyfe-pages/home-tab.png');
const HeaderMobile = require('../../../openbrix-design-system/images/tlyfe-pages/home-mobile.png');
const Picture = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/tlyfepro.png');
const FooterWeb = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-web.png');
const FooterTab = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-tab.png');
const FooterMobile = require('../../../openbrix-design-system/images/tlyfe-pages/rent-ready/footer-mobile.png');
const clouds = require('../../../openbrix-design-system/images/tlyfe-pages/hangingCloud.png');
const mockVideo = require('../../../openbrix-design-system/images/tlyfe-pages/tlyfe-video-mock.png');
const home = require('../../../openbrix-design-system/images/icons/home.png');
const smily = require('../../../openbrix-design-system/images/icons/smily.png');
const pound = require('../../../openbrix-design-system/images/icons/pound.png');
const tlyfeProLogo = require('../../assets/SVG/newIcons/TLYFEPROlLOGI.svg');
const tlyfeProBig = require('../../assets/SVG/newIcons/tlyfePRO.svg');

const BenefitItem = ({ icon, title, description }) => (
  <View style={{ marginTop: 20, flexDirection: "row" }}>
    <Image style={{ height: 30, width: 30, marginRight: 10 }} resizeMode="contain" source={icon} />
    <View style={{ flexDirection: "column", flex: 1 }}>
      <ODSText type="button">{title}</ODSText>
      <ODSText type="sm" style={{ marginTop: 14 }}>{description}</ODSText>
    </View>
  </View>
);

const FEATURES_DATA = [
  {
    title: "Streamlined tenant onboarding",
    description: "tlyfePRO simplifies and accelerates every stage of tenant onboarding through automation and an intuitive dashboard.\n\nSpend less time chasing paperwork and more time closing deals, while ensuring a consistent and professional experience for every applicant.",
    icon: require('./images/logo/sto.png'),
    iconBg: "#9F76C4",
    cardBg: "#F8F2FC",
  },
  {
    title: "Connect with “Rent Ready” tenants",
    description: "tlyfePRO connects directly with the tlyfe tenant app, giving agents access to:\n• Pre-qualified, rent-ready tenants with Verified digital ID and Right-to-Rent checks",
    icon: require('./images/logo/rr.png'),
    iconBg: "#4BA7F2",
    cardBg: "#EAF6FF",
  },
  {
    title: "Maintenance reporting directly from tlyfe",
    description: "Tenants can report any maintenance issues directly off their app using smart technology, AI assistance and reports directly into the tlyfePRO agent dashboard.\n\nThis can be set to include out of office contacts and contractors can be copied in. Provides a log for all parties (backed up by automated emails).",
    icon: require('./images/logo/m.png'),
    iconBg: "#4BA7F2",
    cardBg: "#EAF6FF",
  },
  {
    title: "Integrated compliance and verification",
    description: "tlyfePRO ensures every tenancy meets regulatory requirements through built-in:\n• Right-to-Rent checks.\n• Digital ID verification.\n• Secure document storage.\n\nMaintain full compliance with confidence, supported by a clear and auditable process.",
    icon: require('./images/logo/v.png'),
    iconBg: "#9F76C4",
    cardBg: "#F8F2FC",
  }
];

const TlyfeProFeatureCard = ({ item, style }) => {
  const layout = getScreenType();
  const isPhone = layout === "phone";

  return (
    <View
      style={{
        backgroundColor: item.cardBg,
        borderRadius: 20,
        padding: 24,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 1 },
        shadowOpacity: 0.05,
        shadowRadius: 2,
        elevation: 1,
        minHeight: isPhone ? 220 : 200,
        ...style,
      }}
    >
      <View style={{ flexDirection: isPhone ? "column" : "row", alignItems: "flex-start" }}>
        <View
          style={{
            width: 48,
            height: 48,
            borderRadius: 24,
            backgroundColor: item.iconBg,
            alignItems: "center",
            justifyContent: "center",
            marginRight: 16, marginBottom: isPhone ? 10 : 0
          }}
        >
          <Image
            source={item.icon}
            style={{ width: 24, height: 24, tintColor: "white" }}
            resizeMode="contain"
          />
        </View>
        <View style={{ flex: 1 }}>
          <ODSText
            type="h6"
            color="#1E293B"
            marginBottom={12}
            style={{ fontWeight: "600" }}
          >
            {item.title}
          </ODSText>
          <ODSText
            type="sm"
            color="#475569"
            style={{ lineHeight: 22 }}
            marginBottom={12}
          >
            {item.description}
          </ODSText>
        </View>
      </View>
    </View>
  );
};

const TlyfeProFeatureSlider = () => {
  const { colors } = useTheme();
  const windowWidth = Dimensions.get('window').width;

  const carouselWidth = Math.min(windowWidth * 0.88, 430);
  const itemWidth = carouselWidth;
  const cardWidth = carouselWidth - 20;

  const [activeIndex, setActiveIndex] = React.useState(0);
  const listRef = React.useRef(null);

  const moveSlider = (direction) => {
    const nextIndex = direction === "next"
      ? (activeIndex + 1) % FEATURES_DATA.length
      : (activeIndex - 1 + FEATURES_DATA.length) % FEATURES_DATA.length;

    listRef.current?.scrollToOffset({
      offset: nextIndex * itemWidth,
      animated: true,
    });
    setActiveIndex(nextIndex);
  };

  return (
    <View style={{ flexDirection: "column", width: "100%", alignItems: "center" }}>
      <View style={{
        width: carouselWidth,
        alignSelf: "center",
        position: "relative",
      }}>
        <FlatList
          ref={listRef}
          data={FEATURES_DATA}
          horizontal
          showsHorizontalScrollIndicator={false}
          snapToInterval={itemWidth}
          snapToAlignment="center"
          decelerationRate="fast"
          disableIntervalMomentum
          onMomentumScrollEnd={(event) => {
            setActiveIndex(Math.round(
              event.nativeEvent.contentOffset.x / itemWidth
            ));
          }}
          contentContainerStyle={{
            paddingHorizontal: 10,
          }}
          style={{
            width: "100%",
            alignSelf: "center",
          }}
          keyExtractor={(_, index) => index.toString()}
          renderItem={({ item }) => (
            <View style={{ width: cardWidth, marginHorizontal: 5 }}>
              <TlyfeProFeatureCard item={item} style={{ flex: 1 }} />
            </View>
          )}
        />

        {/* Navigation Arrows */}
        <Pressable
          onPress={() => moveSlider("previous")}
          style={{
            position: "absolute",
            left: 0,
            top: "40%",
            width: 44,
            height: 54,
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <ODSText color={colors.main.blue["500"]} fontSize={52} type="sm">‹</ODSText>
        </Pressable>
        <Pressable
          onPress={() => moveSlider("next")}
          style={{
            position: "absolute",
            right: 0,
            top: "40%",
            width: 44,
            height: 54,
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2,
          }}
        >
          <ODSText color={colors.main.blue["500"]} fontSize={52} type="sm">›</ODSText>
        </Pressable>
      </View>

      {/* Pagination Dots */}
      <View style={{
        flexDirection: "row",
        justifyContent: "center",
        marginTop: 16,
      }}>
        {FEATURES_DATA.map((_, index) => (
          <Pressable
            key={`dot-${index}`}
            onPress={() => {
              listRef.current?.scrollToOffset({
                offset: index * itemWidth,
                animated: true,
              });
              setActiveIndex(index);
            }}
            style={{
              width: 10,
              height: 10,
              borderRadius: 5,
              marginHorizontal: 5,
              backgroundColor: index === activeIndex
                ? colors.main.blue["500"]
                : "rgba(19, 179, 193, 0.3)",
            }}
          />
        ))}
      </View>
    </View>
  );
};

const LEFT_BENEFITS = [
  {
    icon: require('../../../openbrix-design-system/images/icons/pound.png'),
    title: "Lower costs",
    description: "No monthly subscriptions. Pay as you use.",
  },
  {
    icon: require('./images/logo/crm.png'),
    title: "Compliments with your CRM",
    description: "tlyfePRO links with 34 CRM’s including Alto",
  },
  {
    icon: require('./images/logo/sheild.png'),
    title: "Deposit Integration for tenancy onboarding",
    description: "With extra and deep integration using API technology with the TDS where tenants can view and manage their deposit",
  },
];

const RIGHT_BENEFITS = [
  {
    icon: require('./images/logo/ts.png'),
    title: "Time Savings",
    description: "A full tenancy onboarding allows for an approximate 2 minute admin process.",
  },
  {
    icon: require('./images/logo/ie.png'),
    title: "Improved efficiency",
    description: "With a full audit log of all documents served and compliancy actions.",
  },
  {
    icon: require('./images/logo/happy.png'),
    title: "Better tenant experience",
    description: "The only tenancy onboarding process in the UK carried out for the tenants on an app.",
  },
];

const NewBenefitItem = ({ icon, title, description }) => {
  const { colors } = useTheme();
  return (
    <View style={{ marginBottom: 32, flexDirection: "row", alignItems: "flex-start" }}>
      <Image
        style={{ height: 32, width: 32, marginRight: 16, marginTop: 4, tintColor: colors.main.blue["500"] }}
        resizeMode="contain"
        source={icon}
      />
      <View style={{ flexDirection: "column", flex: 1 }}>
        <ODSText type="h6" color="#1E293B" style={{ fontWeight: "700" }}>{title}</ODSText>
        <ODSText type="sm" color="#475569" marginTop={8} style={{ lineHeight: 22 }}>{description}</ODSText>
      </View>
    </View>
  );
};

const TlyfeproLandingHome = () => {
  const { colors } = useTheme();
  const layout = getScreenType();

  const headerImage = layout === "web" ? HeaderWeb : layout === "tab" ? HeaderTab : HeaderMobile;
  const footerImage = layout === "web" ? FooterWeb : layout === "tab" ? FooterTab : FooterMobile;

  const sectionStyles = layout === "phone"
    ? { flexDirection: "column", alignItems: "center", paddingHorizontal: "6%", marginBottom: 30 }
    : { flexDirection: "row", justifyContent: "center", paddingVertical: 100 };

  const introSectionStyles = layout === "phone"
    ? { flexDirection: "column", alignItems: "center", paddingHorizontal: "6%", marginTop: 20, marginBottom: 30 }
    : { flexDirection: "row", justifyContent: "center", alignItems: "center", paddingVertical: 60, width: layout === "web" ? 1056 : "90%", alignSelf: "center" };

  return (
    <Wrapper
      theme={colors.transparency.purple}
      drawerColor={colors.theme.purple}
      type="login"
      isOpenBrixLogo
      imageStyle={layout == "phone" ? { height: 800, justifyContent: "flex-start", paddingTop: 100 } : { height: 500, justifyContent: "center", paddingTop: 20 }}
      headerTitle="Let Smarter With Our Tenant Onboarding Service - tlyfePRO"
      headerBody="tlyfe Professional is the industry leading tenant onboarding solution for letting agents,transforming the tenant onboarding process to enhance efficiency, reduce costs, and boost tenant satisfaction."
      headerImage={headerImage}
      headerBlacFont
      rightImage={Picture}
      leftText={`Give yourself the best chance of securing your next rental property by using our Pre-qualification tool to become a ‘Rent Ready’ Tenant.\n\nShare the results with your Agent to put yourself ahead of the crowd!!`}
      footerImage={footerImage}
      tlyfeProMenu
    >
      <View style={{ position: "relative" }}>
        <Image source={require("../../../openbrix-design-system/images/tlyfe-pages/clouds.png")}
          style={{ width: "100%", height: 100, position: "absolute", top: -97 }} />
        <View style={introSectionStyles}>
          <Image
            style={layout === "phone" ? { height: 100, width: 150 } : { height: 154, width: 231, marginRight: "4%" }}
            resizeMode="contain"
            source={tlyfeProLogo}
          />
          <View style={{ flex: 1, marginLeft: layout === "phone" ? 0 : "2%", marginTop: layout === "phone" ? 20 : 0 }}>
            <ODSText
              type={layout === "phone" ? "sm" : "md"}
              color={colors.text.primary}
              textAlign={layout === "phone" ? "center" : "left"}
              style={{ lineHeight: layout === "phone" ? 22 : 26 }}
            >
              In today’s fast-paced rental market, onboarding tenants quickly and compliantly is more important than ever. Yet, for many letting agents, the process remains manual, time-consuming, and costly. That’s why you need tlyfeProfessional (tlyfePRO), the UK’s leading interactive property platform for letting agents.
            </ODSText>
            <ODSText
              type={layout === "phone" ? "sm-bold" : "md-bold"}
              color={colors.text.primary}
              textAlign={layout === "phone" ? "center" : "left"}
              marginTop={16}
              style={{ lineHeight: layout === "phone" ? 22 : 26 }}
            >
              tlyfePRO empowers letting agents to manage tenancies and engage with tenants through the UK’s leading tenant app, tlyfe™.
            </ODSText>
          </View>
        </View>
        <View style={{ width: layout === "web" ? 1056 : "90%", alignSelf: "center", marginTop: 20, marginBottom: 60 }}>
          {layout === "phone" ? (
            <TlyfeProFeatureSlider />
          ) : (
            <View style={{ flexDirection: "column" }}>
              <View style={{ flexDirection: "row", marginBottom: 24 }}>
                <TlyfeProFeatureCard item={FEATURES_DATA[0]} style={{ flex: 1, marginRight: 12 }} />
                <TlyfeProFeatureCard item={FEATURES_DATA[1]} style={{ flex: 1, marginLeft: 12 }} />
              </View>
              <View style={{ flexDirection: "row" }}>
                <TlyfeProFeatureCard item={FEATURES_DATA[2]} style={{ flex: 1, marginRight: 12 }} />
                <TlyfeProFeatureCard item={FEATURES_DATA[3]} style={{ flex: 1, marginLeft: 12 }} />
              </View>
            </View>
          )}
        </View>
        <View style={{ width: layout === "web" ? 1056 : "90%", alignSelf: "center", }}>
          <ODSText
            type="h2"
            color={colors.main.blue["500"]}
            textAlign="center"
            marginBottom={layout === "phone" ? 30 : 60}
          >
            Key Benefits
          </ODSText>

          {layout === "phone" ? (
            <View style={{ flexDirection: "column" }}>
              {LEFT_BENEFITS.map((item, index) => (
                <NewBenefitItem key={`left-${index}`} icon={item.icon} title={item.title} description={item.description} />
              ))}
              {RIGHT_BENEFITS.map((item, index) => (
                <NewBenefitItem key={`right-${index}`} icon={item.icon} title={item.title} description={item.description} />
              ))}
            </View>
          ) : (
            <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
              <View style={{ flex: 1, marginRight: 32 }}>
                {LEFT_BENEFITS.map((item, index) => (
                  <NewBenefitItem key={`left-${index}`} icon={item.icon} title={item.title} description={item.description} />
                ))}
              </View>
              <View style={{ flex: 1, marginLeft: 32 }}>
                {RIGHT_BENEFITS.map((item, index) => (
                  <NewBenefitItem key={`right-${index}`} icon={item.icon} title={item.title} description={item.description} />
                ))}
              </View>
            </View>
          )}
        </View>
        <View style={layout === "phone" ?
          { ...sectionStyles, paddingTop: 20, backgroundColor: colors.main.purple["500"], justifyContent: "center", alignItems: "center", flexDirection: "column-reverse" } :
          { ...sectionStyles, backgroundColor: colors.main.purple["500"], height: 422, justifyContent: "center", alignItems: "center" }}>
          {layout == "phone" ? null : <>
            <Image
              style={layout === "phone" ? { height: 100, width: 73, position: "absolute", top: 0, right: 20 } : { height: 100, width: 73, position: "absolute", top: 0, right: 20 }}
              source={clouds}
            />
            <Image
              style={layout === "phone" ? { height: 52, width: 41, position: "absolute", top: 0, left: 40 } : { height: 52, width: 41, position: "absolute", top: 0, left: 40 }}
              source={clouds}
            />
          </>}

          <View style={{ marginLeft: layout === "phone" ? "0%" : "2%", position: "relative" }}>
            <Image
              style={layout === "phone" ? { height: 241, width: 360, bottom: -30 } : { height: 422, width: 638, marginRight: "2%", bottom: -90 }}
              resizeMode="contain"
              source={mockVideo}
            />
          </View>
          <View style={layout === "phone" ? {} : { marginLeft: "2%", width: "31%" }}>
            <ODSText color="white" type="h3">Seamless Integration</ODSText>
            <ODSText color="white" marginTop={10} type="sm">
              TlyfePRO integrates effortlessly with our Tlyfe tenant app and existing CRM solutions, offering a complete service that improves the rental experience for both tenants, landlord and agents.               </ODSText>
          </View>
        </View>
        <View style={layout === "phone" ? { ...sectionStyles, height: 260 } : { ...sectionStyles, marginTop: 100, height: 687 }}>
          <View style={{ marginLeft: "2%", width: 840 }}>

          </View>
        </View>
        <View style={layout === "phone" ?
          { ...sectionStyles, height: 142, paddingTop: 20, justifyContent: "center", alignItems: "center", flexDirection: "column-reverse", backgroundColor: colors.main.purple["400"], position: "relative", marginBottom: 0 } :
          { ...sectionStyles, flexDirection: "column", height: 322, justifyContent: "center", alignItems: "center", backgroundColor: colors.main.purple["400"], position: "relative", padding: layout == "tab" ? "10%" : "web" ? "16%" : "10%" }}>
          <View style={layout === "phone" ? { top: -147, width: "100%" } : { top: -360, width: "100%" }}>
            {layout === "phone" ?
              <>
                <ODSText type="h3" color={"black"} textAlign={layout !== "phone" ? "center" : "center"}>Transform Your Process</ODSText>
                <ODSText type="h5" color={"black"} textAlign={layout !== "phone" ? "center" : "center"} marginTop={10} marginBottom={20}>
                  Experience the future of property management with tlyfePRO. Enhance yourefficiency, reduce costs, and ensure tenant satisfaction, all through one powerful platform.
                </ODSText>
              </>

              : <>
                <ODSText type="h3" color={"black"} textAlign={layout !== "phone" ? "center" : "center"}>Transform Your Process</ODSText>
                <ODSText type="sm" color={"black"} textAlign={layout !== "phone" ? "center" : "center"} marginTop={20}>

                </ODSText>
                <ODSText type="sm" color={"black"}
                  marginTop={5}
                  textAlign={layout !== "phone" ? "center" : "center"}>
                  Enhance yourefficiency, reduce costs, and ensure tenant
                </ODSText>
                <ODSText
                  marginTop={5}
                  marginBottom={40}
                  type="sm" color={"black"} textAlign={layout !== "phone" ? "center" : "center"}>
                  satisfaction, all through one powerful platform.
                </ODSText>
              </>}


            <View style={layout == "phone" ? { height: 200, } : { height: 800, }}>
              {/* <YoutubePlayer
                url={'https://www.youtube.com/watch?v=4T0oKyMI6wI'}
                width="100%"
                height="100%"
                style={{ borderTopRightRadius: 8, borderTopLeftRadius: 8, overflow: 'hidden' }}
              /> */}
              <Image
                source={tlyfeProBig}
                style={{ width: "100%", height: "100%" }}
                resizeMode="contain"
              />
            </View>
          </View>
        </View>
      </View>
    </Wrapper>
  );
};

export default TlyfeproLandingHome;
